import { render, staticRenderFns } from "./padron-download.vue?vue&type=template&id=0cbbd9de&"
import script from "./padron-download.component.ts?vue&type=script&lang=ts&"
export * from "./padron-download.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports